/**
 * Accessible carrousel.
 * https://van11y.net/accessible-carrousel/
 */

import Van11yCarousel from 'van11y-accessible-carrousel-aria';

window.addEventListener('load', () => {
  const galleryNextButton = document.querySelector('.image-gallery .js-carrousel__button__next');
  const galleryDots = document.querySelectorAll('.image-gallery .js-carrousel__control__list__link');

  autoplay = setInterval(() => {
    galleryNextButton.click();
  }, 3000);

  galleryDots.forEach((dot) => {
    dot.addEventListener('click', () => clearInterval(autoplay));
  });
});
